import React from 'react';
import { Translate, I18n } from 'react-redux-i18n';
import { connect } from 'react-redux';
import Tooltip from '../../../../common/tooltip/SimpleTooltip';
import './index.scss';

const RANKING_TOOLTIP = (
  <div className="d-flex flex-column">
    <div>
      <Translate value={'commonFundamental.rankingTooltip.oneLine'} />
    </div>
    <div>
      <Translate value={'commonFundamental.rankingTooltip.twoLine'} />
    </div>
  </div>
);

const SCORE_TOOLTIP = (
  <div>
    <div className="d-flex flex-column text-left">
      <div>
        <Translate value={'commonFundamental.scoreTooltip.oneLine'} />
      </div>
      <div>
        <Translate value={'commonFundamental.scoreTooltip.twoLine'} />
      </div>
    </div>
    <div className="score-box-tooltip-wrapper">
      <div className="score-line">
        <div className="score-dot F-dot" />
        <div className="score-dot E-dot" />
        <div className="score-dot D-dot" />
        <div className="score-dot C-dot" />
        <div className="score-dot B-dot" />
        <div className="score-dot A-dot" />
      </div>
    </div>
    <div className="d-flex justify-content-between">
      <div>
        <Translate value={'commonFundamental.LOWEST'} />
      </div>
      <div>
        <Translate value={'commonFundamental.HIGHEST'} />
      </div>
    </div>
  </div>
);

class ScoreBox extends React.Component {
  getColorOFbfsCore = score => {
    switch (score) {
      case 'B':
        return 'box bg-box-b';
      case 'C':
        return 'box bg-box-c';
      case 'D':
        return 'box bg-box-d';
      case 'E':
        return 'box bg-box-e';
      case 'F':
        return 'box bg-box-f';
      default:
        return 'box bg-box-a';
    }
  };

  formatText = text => {
    return text || '--';
  };

  getIndustryName = code => {
    const { listIndustryByIcbCode } = this.props;
    if (
      !code ||
      !Object.keys(listIndustryByIcbCode).length ||
      !listIndustryByIcbCode[code]
    ) {
      return '--';
    }
    const industryInfo = listIndustryByIcbCode[code];
    return industryInfo.icbName;
  };

  render() {
    const {
      data: {
        value,
        vgm,
        growth,
        momentum,
        icbRank,
        icbTotalRanked,
        indexRank,
        indexTotalRanked,
        comGroupCode,
        icbCode,
      },
    } = this.props;

    const industryName = this.getIndustryName(icbCode);

    return (
      <div className="score-box" id="score">
        <div className="d-flex">
          <div className="d-flex align-items-center mr-3">
            <div className="bfs-12 mr-1">
              {I18n.t('commonFundamental.scoreBox.fiinTradeRank')}
            </div>
            <Tooltip message={RANKING_TOOLTIP} position={'right'}>
              <i className="icon-info bfs-10" />
            </Tooltip>
          </div>

          <div className="d-flex align-items-baseline mr-3">
            <div className="mr-2 fw-bold bfs-14">{`${this.formatText(
              icbRank,
            )}/${this.formatText(icbTotalRanked)}`}</div>
            <div className="bfs-10">{industryName}</div>
          </div>

          <div className="d-flex align-items-baseline">
            <div className="mr-2 fw-bold bfs-14">{`${this.formatText(
              indexRank,
            )}/${this.formatText(indexTotalRanked)}`}</div>
            <div className="bfs-10">{`${this.formatText(comGroupCode)}`}</div>
          </div>
        </div>

        <div className="score-box__line">
          <div className="d-flex align-items-center mr-3">
            <div className="bfs-12 mr-1">
              <Translate value="commonFundamental.scoreBox.score" />
            </div>
            <Tooltip message={SCORE_TOOLTIP} position={'right'}>
              <i className="icon-info bfs-10" />
            </Tooltip>
          </div>
          <div className="d-flex mr-10">
            <div className={this.getColorOFbfsCore(value)}>{value}</div>
            <div>{I18n.t('commonFundamental.scoreBox.value')}</div>
          </div>
          <div className="d-flex mr-10">
            <div className={this.getColorOFbfsCore(growth)}>{growth}</div>
            <div>
              <Translate value="commonFundamental.scoreBox.growth" />
            </div>
          </div>
          <div className="d-flex mr-10">
            <div className={this.getColorOFbfsCore(momentum)}>{momentum}</div>
            <div>
              <Translate value="commonFundamental.scoreBox.momentum" />
            </div>
          </div>
          <div className="d-flex">
            <div className={this.getColorOFbfsCore(vgm)}>{vgm}</div>
            <div>
              <Translate value="commonFundamental.scoreBox.vgm" />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ScoreBox.defaultProps = {
  data: {
    value: '',
    vgm: '',
    growth: '',
    momentum: '',
    icbRank: '',
    icbTotalRanked: '',
    indexRank: '',
    indexTotalRanked: '',
    comGroupCode: '',
    icbCode: '',
  },
};

const mapStateToProps = state => {
  return {
    i18n: state.i18n,
    listIndustryByIcbCode: state['COMMON:'].listIndustryByIcbCode,
  };
};

export default connect(mapStateToProps)(ScoreBox);
